import React, { useState } from 'react';

function getVideoTypeAndUrl(url) {
  if (!url) return null;

  // 1. YouTube
  const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/]+)/);
  if (ytMatch) {
    return { type: 'iframe', url: `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1` };
  }

  // 2. Vimeo
  if (url.includes('vimeo.com')) {
    const vMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vMatch) {
      return { type: 'iframe', url: `https://player.vimeo.com/video/${vMatch[1]}?autoplay=1` };
    }
  }

  // 3. Facebook
  if (url.includes('facebook.com') || url.includes('fb.watch')) {
    return { type: 'iframe', url: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=560&autoplay=true` };
  }

  // 4. Instagram
  if (url.includes('instagram.com')) {
    const cleanUrl = url.split('?')[0].replace(/\/$/, '');
    return { type: 'iframe', url: `${cleanUrl}/embed/` };
  }

  // 5. Direct Video File (Amazon S3 / MP4 / etc.)
  const lowerUrl = url.toLowerCase();
  if (
    lowerUrl.endsWith('.mp4') ||
    lowerUrl.endsWith('.webm') ||
    lowerUrl.endsWith('.ogg') ||
    lowerUrl.endsWith('.mov') ||
    lowerUrl.includes('amazonaws.com')
  ) {
    return { type: 'video', url: url };
  }

  return null;
}


export function PostModal({ post, onClose, settings }) {
  const [imgIdx, setImgIdx] = useState(0);
  const video = getVideoTypeAndUrl(post.video_url);
  const hasImages = post.images && post.images.length > 0;

  const shareUrl = `${window.location.origin}${window.location.pathname}?post=${post.id}`;
  const whatsappText = encodeURIComponent(`*${post.title}*\n\n${shareUrl}`);
  const whatsappUrl = `https://api.whatsapp.com/send?text=${whatsappText}`;

  const handleShare = (e) => {
    e.stopPropagation();
    
    if (navigator.share) {
      navigator.share({
        title: post.title,
        text: post.description || '',
        url: shareUrl
      }).catch(() => {});
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        alert('Enlace de la publicación copiado al portapapeles.');
      }).catch(() => {
        alert('No se pudo copiar el enlace. URL: ' + shareUrl);
      });
    }
  };

  return (
    <div className="post-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="post-modal" style={{ position: 'relative' }}>

        {/* Media */}
        <div className="post-modal-media">
          {video ? (
            video.type === 'iframe' ? (
              <iframe src={video.url} title={post.title} allow="autoplay" allowFullScreen />
            ) : (
              <video src={video.url} controls autoPlay style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }} />
            )
          ) : hasImages ? (
            <>
              <img src={post.images[imgIdx]} alt={`slide-${imgIdx}`} />
              {post.images.length > 1 && (
                <>
                  <button className="modal-gallery-nav prev" onClick={() => setImgIdx(i => (i - 1 + post.images.length) % post.images.length)}>‹</button>
                  <button className="modal-gallery-nav next" onClick={() => setImgIdx(i => (i + 1) % post.images.length)}>›</button>
                  <div className="modal-dots">
                    {post.images.map((_, i) => <span key={i} className={i === imgIdx ? 'active' : ''} />)}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ color: '#333', fontSize: '3rem' }}>🎬</div>
          )}
        </div>

        {/* Side */}
        <div className="post-modal-side">
          <div className="post-modal-header" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="post-modal-avatar">
              {settings?.logo_circular_url
                ? <img src={settings.logo_circular_url} alt="logo" />
                : '🎬'}
            </div>
            <span className="post-modal-username" style={{ marginRight: 'auto' }}>{settings?.site_title || 'El Popular'}</span>
          </div>

          <div className="post-modal-body">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
              <h3 style={{ color: '#b81623', margin: 0, fontSize: '1.05rem', fontWeight: 700 }}>{post.title}</h3>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexShrink: 0 }}>
                {/* Share Link */}
                <button onClick={handleShare} style={{ background: 'none', border: 'none', color: 'var(--text)', cursor: 'pointer', fontSize: '1rem', padding: '4px', display: 'flex', alignItems: 'center' }} title="Copiar enlace">
                  🔗
                </button>
                {/* Share WhatsApp */}
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', padding: '4px' }} title="Compartir por WhatsApp">
                  <svg width="18" height="18" viewBox="0 0 448 512" fill="#25D366">
                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l127.7-33.6C161.6 465.3 198.5 480 223.9 480c122.4 0 222-99.6 222-222 0-59.3-25.2-115-65-154.9zM223.9 446.2c-31.4 0-62.2-8.5-88.9-24.5l-6.4-3.8-75.8 19.9 20.3-74-4.2-6.7c-17.6-28-26.9-60.4-26.9-93.8 0-101.3 82.4-183.7 183.7-183.7 49 0 95.1 19.1 129.8 53.8 34.7 34.7 53.8 80.9 53.8 129.9-.1 101.4-82.5 183.8-183.8 183.8zm101.4-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                  </svg>
                </a>
                {/* Close Button X next to WhatsApp */}
                <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: '1.5rem', padding: '4px', display: 'flex', alignItems: 'center', marginLeft: '4px', lineHeight: 1 }} title="Cerrar">
                  ×
                </button>
              </div>
            </div>
            {post.description && <p style={{ marginTop: '.5rem' }}>{post.description}</p>}
          </div>

          <div className="post-modal-date">
            {new Date(post.created_at).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>

      </div>
    </div>
  );
}

export default function PostCard({ post, onOpen }) {
  const video = getVideoTypeAndUrl(post.video_url);
  const hasImages = post.images && post.images.length > 0;
  const thumb     = hasImages ? post.images[0] : null;

  return (
    <>
      <div className="grid-item" onClick={onOpen}>
        {thumb ? (
          <img src={thumb} alt={post.title} />
        ) : video ? (
          video.type === 'video' ? (
            <video src={video.url} muted playsInline style={{ width:'100%', height:'100%', objectFit:'cover' }} preload="metadata" />
          ) : (
            <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>▶</div>
          )
        ) : (
          <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>🎬</div>
        )}

        {/* Badge múltiples fotos o video */}
        {hasImages && post.images.length > 1 && (
          <span className="grid-item-badge">⧉</span>
        )}
        {video && (
          <span className="grid-item-badge">▶</span>
        )}

        <div className="grid-item-overlay">
          <span>🎬 {post.title}</span>
        </div>
      </div>
    </>
  );
}
